const courseEventResults = {
  EMPTY: { name: 'No ha finalizado', id: 3 },
  passed: { name: 'Aprobado', id: 0 },
  failed: { name: 'Reprobado', id: 1 },
  abandoned: { name: 'Abandonado', id: 2 },
};

export default courseEventResults;
